import { render, staticRenderFns } from "./card-client-user.vue?vue&type=template&id=b1b24f5a&"
import script from "./card-client-user.vue?vue&type=script&lang=js&"
export * from "./card-client-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports